/* Search page — two behaviour patches for the Spectrum search results snippet
   (sai-oe9qy9lz), which builds its cards client-side. Done here (theme-owned
   override) rather than in the generated snippet so they survive a regen.

   1. Quick-view → shared mini-PDP. For multi-variant products the card renders a
      `.sai-oe9qy9lz__card-quickview` button whose own handler opens the search
      component's OWN mini-PDP — which looks nothing like the PLP card's mini-PDP.
      We intercept that click in the capture phase (before the snippet's handler
      runs), stop it, and open the standard quick-add dialog instead.

   2. Card → PDP navigation. The generated cards render with
      data-navigate-to-pdp="false", so the snippet binds NO click-to-navigate
      handler and the cards are dead <div>s (can't reach the PDP). We make the
      whole card open the PDP — except the add-to-cart CTA (adds to cart) and the
      quick-view button (case 1). The card already has tabindex="0", so we also
      handle Enter for keyboard users.

   Single-variant cards use `.sai-oe9qy9lz__card-atc` (direct add to cart), left
   untouched for the add action.

   Capture-phase + document-level delegation means this is robust to the grid
   re-rendering on filter / sort / pagination — no per-card wiring needed. */
(function () {
  if (window.__spectrumSearchQuickAdd) return;
  window.__spectrumSearchQuickAdd = true;

  function goToPdp(card) {
    var handle = card && card.getAttribute('data-handle');
    if (handle) window.location.href = '/products/' + handle;
  }

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      // 1) Quick-view button → open the shared quick-add dialog.
      var btn = target.closest('.sai-oe9qy9lz__card-quickview');
      if (btn) {
        // Resolve the product handle from the card (always present) with the
        // stamped trigger attribute as a fallback.
        var qvCard = btn.closest('.sai-oe9qy9lz__product');
        var handle =
          (qvCard && qvCard.getAttribute('data-handle')) ||
          btn.getAttribute('data-spectrum-quick-add-trigger');

        var qa = window.spectrumQuickAdd;
        // If the standard quick-add isn't available, let the snippet's own
        // mini-PDP handle it (don't break the button).
        if (handle && qa && typeof qa.open === 'function') {
          // Stop the snippet's own click handler (bubble phase) from opening its
          // mini-PDP, then open the shared one.
          e.stopImmediatePropagation();
          e.preventDefault();
          qa.open(handle);
        }
        return;
      }

      // 2) Anywhere else on the card → navigate to the PDP. Skip the direct
      // add-to-cart CTA so it can still add to cart.
      if (target.closest('.sai-oe9qy9lz__card-atc')) return;
      goToPdp(target.closest('.sai-oe9qy9lz__product'));
    },
    true // capture
  );

  // Keyboard: the card is focusable (tabindex="0") — Enter opens the PDP.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.classList && t.classList.contains('sai-oe9qy9lz__product')) {
      goToPdp(t);
    }
  });
})();
